
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/billing",
      function () {
        return require("private-next-pages/billing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/billing"])
      });
    }
  